import { Select } from 'common-front/src/designSystem/components/select/select';
import { TableFilters } from 'common-front/src/designSystem/components/tableFilters';
import { TextInput } from 'common-front/src/designSystem/components/textInput';
import { useEnumToOptions } from 'common-front/src/hooks/useEnumToOptions';
import { useHeavent } from 'common-front/src/hooks/useHeavent';
import { usePaginationInfos } from 'common-front/src/hooks/usePaginationInfos';
import { useStateDebounce } from 'common-front/src/hooks/useStateDebounce';
import { Box } from 'common/src/designSystem/components/box';
import { Flex } from 'common/src/designSystem/components/flex';
import { Spacer } from 'common/src/designSystem/components/spacer';
import { HeaderCell } from 'common/src/designSystem/components/table/headerCell';
import { RowSkeleton } from 'common/src/designSystem/components/table/rowSkeleton';
import {
    ALL_TEXTMESSAGEREPLIES,
    ALL_TEXTMESSAGESTATE,
    CampaignQuery,
    TextMessageReplies,
    TextMessageState
} from 'common/src/generated/types';
import { isNonEmptyString } from 'common/src/util/string';
import * as React from 'react';
import { useCampaignTextMessagesQuery } from '../../generated/graphqlHooks';
import { CampaignKpi } from '../campaignKpi';
import { CampaignTextMessageRow } from './campaignTextMessageRow';

interface ICampaignTextMessageProps {
    campaign: CampaignQuery['organization']['campaign'];
}

export const CampaignTextMessage = (props: ICampaignTextMessageProps) => {
    const {
        params: { organizationId, campaignId },
        translate
    } = useHeavent();
    const [name, nameDebounced, setName] = useStateDebounce('');
    const [state, setState] = React.useState<'' | TextMessageState>('');
    const [replies, setReplies] = React.useState<'' | TextMessageReplies>('');
    const [offset, setOffset] = React.useState(0);
    const { data, isLoading } = useCampaignTextMessagesQuery({
        organizationId,
        campaignId,
        name: isNonEmptyString(nameDebounced) ? nameDebounced : undefined,
        state: state !== '' ? state : undefined,
        replies: replies !== '' ? replies : undefined,
        offset
    });
    const enumToOptions = useEnumToOptions();
    const { numberOfPages, totalCount } = usePaginationInfos(
        data.organization?.campaign.textMessages
    );

    return (
        <>
            <Flex gap="6">
                <CampaignKpi
                    content={props.campaign.numberOfRecipients}
                    title={translate('nombre_de_desti_21374')}
                />

                <CampaignKpi
                    content={props.campaign.numberOfDelivery ?? 0}
                    title={translate('nombre_de_messa_93859')}
                />

                <CampaignKpi
                    content={props.campaign.cost}
                    title={translate('co_t_de_la_camp_54312')}
                />
            </Flex>

            <Spacer height="7" />

            <TableFilters
                filters={
                    <>
                        <Box width={200}>
                            <Select
                                value={state}
                                onChange={(newState: '' | TextMessageState) => {
                                    setState(newState);
                                    setOffset(0);
                                }}
                            >
                                <option value="">{translate('tous_les_status_67644')}</option>

                                {enumToOptions(ALL_TEXTMESSAGESTATE)}
                            </Select>
                        </Box>

                        <Box width={240}>
                            <Select
                                value={replies}
                                onChange={(newReplies: '' | TextMessageReplies) => {
                                    setReplies(newReplies);
                                    setOffset(0);
                                }}
                            >
                                <option value="">{translate('avec_et_sans_r_23765')}</option>

                                {enumToOptions(ALL_TEXTMESSAGEREPLIES)}
                            </Select>
                        </Box>

                        <Box width={320}>
                            <TextInput
                                icon="magnifying-glass"
                                placeholder={translate('rechercher_un_d_02329')}
                                value={name}
                                onChange={(newName: string) => {
                                    setName(newName);
                                    setOffset(0);
                                }}
                            />
                        </Box>
                    </>
                }
                headerCells={
                    <>
                        <HeaderCell>{translate('nom_du_membre_69353')}</HeaderCell>
                        <HeaderCell>{translate('Phone')}</HeaderCell>
                        <HeaderCell>{translate('date_d_envoi_74668')}</HeaderCell>
                        <HeaderCell>{translate('status_06428')}</HeaderCell>
                        <HeaderCell>{translate('r_ponses_97000')}</HeaderCell>
                    </>
                }
                numberOfPages={numberOfPages}
                offset={offset}
                rows={
                    isLoading ? (
                        <>
                            <RowSkeleton bx={true} />
                            <RowSkeleton bx={true} />
                            <RowSkeleton bx={true} />
                        </>
                    ) : (
                        <>
                            {data.organization.campaign.textMessages.nodes.map(
                                (textMessage, index) => (
                                    <CampaignTextMessageRow
                                        key={index}
                                        createdBy={data.organization.campaign.createdBy}
                                        text={props.campaign.text}
                                        textMessage={textMessage}
                                    />
                                )
                            )}
                        </>
                    )
                }
                setOffset={setOffset}
                title={translate('liste_des_desti_16448')}
                totalCount={totalCount}
            />
        </>
    );
};
